import { render } from "./SelectionTiles.vue?vue&type=template&id=2fc8bb5d&scoped=true"
import script from "./SelectionTiles.vue?vue&type=script&lang=js"
export * from "./SelectionTiles.vue?vue&type=script&lang=js"

import "./SelectionTiles.vue?vue&type=style&index=0&id=2fc8bb5d&scoped=true&lang=scss"

import exportComponent from "/var/www/production/releases/52/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc8bb5d"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QIcon,QCardSection,QTooltip});qInstall(script, 'directives', {Ripple});
